module.exports = "<div #script style=\"display: none\">\n  <ng-content></ng-content>\n</div>\n"